import { createFileRoute } from '@tanstack/react-router';
import { pageHead } from '@/lib/routeHead';
import { PasswordRecoveryFlow } from '@/components/shared/PasswordRecoveryFlow';

export const Route = createFileRoute('/reset-password')({
  head: () => pageHead('Reset password | AKIVA', 'Reset your AKIVA account password securely.', '/reset-password', true),
  component: () => <PasswordRecoveryFlow portal="account" />,
});